import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class SubItem2 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item2">
                <Row style={{backgroundColor: "f4f4f4", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Oportunidades de trabajo</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El Técnico Superior Universitario en Diseño Interior abre una amplia gama de opciones profesionales al egresado que le permiten ingresar a un amplio mercado laboral en áreas específicas como: Estudios de Diseño Interior y Arquitectura; Constructoras; Empresas de consultoría de Diseño Interior; Empresas de montaje de eventos, espectáculos, escenografías; Comercios: stands y vitrinas. Diseñador freelance.
                        </div>
                    </Col>
                    <Col md={4}>
                    
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem2;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoInterior/SubItem2.jsx